@if ({
role: role$ | async
}; as vm) {
  <app-main-dialog (dismiss)="dismiss()">
    <div desktopTitle>
      {{ 'calendar.site.name' | translate }}
    </div>
    <app-ticket [roomTicket]="roomTicket()"
      (segment)="segmentValue.set($event)"
      (dismiss)="dismiss()"></app-ticket>
  </app-main-dialog>
}